/**Import react section */
import React, { useState, useEffect } from 'react'
import propTypes from 'prop-types'

/**Import Material UI section */
import { Grid } from '@material-ui/core'

/**Import component section */
import SparePartSalesForm from './SparePartSalesForm'
//import MapComponet from '../../services/components/MapComponent'
import { PositionMapDefault } from '../../../store/helpers/AppConstants'

const AddressComponent = (props) => {
    const { onSaveSparePartRequest, requestDraft, isSaving,isAuthorizadoForEditedData, mode, 
        isVisibleChipsAssignement, isMobile} = props;
    const [mapPositionModel, setPositionModel] = useState({
        latitude: PositionMapDefault.latitude,
        longitude: PositionMapDefault.longitude
    })
	let isActiveButtonInModeCreate = mode !=="MODE_SHOW" ? true : false;
    const [addressModel, setAddressModel] = useState({ Address: {} })
    //const [directionsProvider, setDirectionsProvider] = useState([])

    // Seeded when the folio changes, not on every arrival of its data.
    //
    // The open order refreshes itself in the background now, and each refresh that carries a
    // different value hands down a new object. Depending on that object meant re-seeding the form
    // whenever anything on the order moved -- a carrier status, an ETA -- and re-seeding throws
    // away whatever the user had typed and not yet saved. The case is not hypothetical: editing a
    // tracking number turns the row's status to Not found, and that alone was enough to empty the
    // contact fields under the user's hands.
    //
    // Keyed on the token because that is what makes it a different folio. Within the same folio
    // the form is the user's, and the server does not get to overwrite it mid-edit.
    const requestDraftToken = requestDraft && requestDraft.Token
    useEffect(() => {
        setAddressModel(requestDraft)
        // if(requestDraft && isActiveButtonInModeCreate && !requestDraft.Address){
        //     setDirectionsProvider(requestDraft.Address)
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestDraftToken, isActiveButtonInModeCreate])

    useEffect(() => {
        if (requestDraft && requestDraft.Address && !!requestDraft.Address.longitude) {
            setPositionModel({
                latitude: requestDraft.Address.latitude,
                longitude: requestDraft.Address.longitude
            })
        }
    }, [requestDraft])

    /**
 * Function add map position
 * @param {*} position
 */
    // const onChangePosition = (position) => {
    //     setPositionModel({ latitude: position.lat, longitude: position.lng })
    // }

    /**
 * Action ok Change address
 * @param {*} address
 */
    // const onChangeAddress = (address) => {
    //     setAddressModel({
    //         ...addressModel,
    //         Address: address
    //     })
    // }

    return (
        <Grid container
        spacing={1}
        direction='row'>
            {/* <Grid item xs={12}>
                <Typography variant='subtitle1'><strong>ADDRESS</strong></Typography>
            </Grid>
            <Grid item xs={isMobile ? 12 : 6}>
                <MapComponet
                    position={mapPositionModel}
                    onChangePosition={onChangePosition}
                    onChangeAddress={onChangeAddress}
                    directions={directionsProvider}
                    modeCreate={isActiveButtonInModeCreate}
                    fullAddress={addressModel && addressModel.Address && addressModel.Address.full_address}
                    isMobile={isMobile}
                />
            </Grid> */}
         
                <SparePartSalesForm
                    sparePartSales={addressModel}
                    mapPosotionModel={mapPositionModel}
                    onSaveSparePartRequest={onSaveSparePartRequest}
                    isSaving={isSaving}
                    isAuthorizadoForEditedData={isAuthorizadoForEditedData}
                    isModeCreate={(isAuthorizadoForEditedData && requestDraft && !requestDraft.IsClosed)}
                    isVisibleChipsAssignement={isVisibleChipsAssignement}
                    isMobile={isMobile}
                />

          
        </Grid>
    )
}

AddressComponent.propTypes = {
	/**
	 * The list of all the active services, shown in the service selector
	 */
	isAuthorizadoForEditedData: propTypes.bool.isRequired,
	/**
	 * Callback executed when an active service is selected
	 */
	isSaving: propTypes.bool.isRequired,
	/**
	 * Callback executed when the user save or add a spare part
	 */
	onSaveSparePartRequest: propTypes.func.isRequired,
	/**
	 * Callback executed when removing a spare part
	 */
	requestDraft: propTypes.object,
	/**
	 * Callback executed when the user submits the request
	 */
	onSubmitRequest: propTypes.func
}
AddressComponent.defaultProps = {
    requestDraft: {
        Address: null,
        Service: null,
		SpareParts: []
    },
    isSaving: false,
    isAuthorizadoForEditedData: false,
	onSaveSparePartRequest: () => console.warn('Callback [onSaveSparePartRequest] no defined')
}


export default AddressComponent
